import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Analytics from '../Analytics';
import { RootState } from '../ApplicationState';

export function usePageView(pageName: string): void {
  const userProfile = useSelector((state: RootState) => state.user.userProfile);
  const loggedFor = useRef<string | null>(null);

  useEffect(() => {
    if (!userProfile) return;
    // Profile updates (e.g. the bell's messageMark) replace the object; log once per page and user.
    const key = `${pageName}:${userProfile.userId}`;
    if (loggedFor.current === key) return;
    loggedFor.current = key;
    Analytics.pageView(window.location.href, pageName, userProfile).catch((error) =>
      console.error('[Analytics] pageView failed:', error),
    );
  }, [pageName, userProfile]);
}
